import { render, staticRenderFns } from "./MissionVision.vue?vue&type=template&id=2b95fc34&scoped=true&"
import script from "./MissionVision.vue?vue&type=script&lang=js&"
export * from "./MissionVision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b95fc34",
  null
  
)

export default component.exports